import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaHome,
  FaInfoCircle,
  FaListUl,
  FaEnvelope,
  FaBars,
  FaTimes,
  FaCaretDown,
  FaUser,
  FaRocket,
  FaUserTie,
  FaUserPlus,
  FaChartLine,
  FaClock,
  FaCogs,
  FaUsers,
  FaProjectDiagram,
  FaShieldAlt,
  FaFileAlt,
  FaBuilding,
  FaUserFriends,
  FaLifeRing,
  FaBriefcase,
  FaUserCheck,
  FaChartBar,
  FaBusinessTime,
  FaGraduationCap,
  FaIdCard,
  FaRobot,
  FaExchangeAlt,
  FaFolderOpen,
  FaSearch,
  FaCheckCircle,
  FaChartPie,
  FaLock,
  FaFileContract,
  FaDollarSign,
  FaQuestionCircle,
  FaGlobe,
  FaPhone,
  FaHandshake,
  FaGift,
  FaBook
} from "react-icons/fa";
import "./Header.css";
import WebsiteTranslator from "./WebsiteTranslator";
import API_BASE_URL from "../config";
import AccessRecruitPage from "./AccessRecruitPage";
import MaintenanceNotice from "./MaintenanceNotice";

export default function QuantumHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [featuresOpen, setFeaturesOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [isLoginForm, setIsLoginForm] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      setScrolled(isScrolled);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setFeaturesOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleOpenAuthModal = (event) => {
      const { isLoginForm } = event.detail;
      setIsLoginForm(isLoginForm);
      setAuthModalOpen(true);
      setMenuOpen(false);
      setFeaturesOpen(false);
    };

    window.addEventListener('openAuthModal', handleOpenAuthModal);

    return () => {
      window.removeEventListener('openAuthModal', handleOpenAuthModal);
    };
  }, []);

  const handleLinkClick = () => {
    setMenuOpen(false);
    setFeaturesOpen(false);
  };

  const toggleFeatures = () => {
    setFeaturesOpen(!featuresOpen);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    if (menuOpen) {
      setFeaturesOpen(false);
    }
  };

  const handleLogin = () => {
    console.log('Login button clicked - navigating to /login');
    navigate('/login');
  };

  const handleGetStarted = () => {
    console.log('Start Hiring button clicked - navigating to /signup');
    navigate('/signup');
  };

  const handleMobileLogin = () => {
    console.log('Mobile Login button clicked - navigating to /login');
    navigate('/login');
    setMenuOpen(false);
  };

  const handleMobileGetStarted = () => {
    console.log('Mobile Get Started button clicked - navigating to /signup');
    navigate('/signup');
    setMenuOpen(false);
  };

  const closeAuthModal = () => setAuthModalOpen(false);

  return (
    <>
      <MaintenanceNotice />
      <nav className={`quantum-nav ${scrolled ? "quantum-nav--scrolled" : ""}`}>
        <div className="quantum-nav__container">
          {/* Logo Section */}
          <div className="quantum-nav__brand">
            <Link to="/" onClick={handleLinkClick} className="quantum-nav__logo">
              <div className="quantum-nav__logo-orb">
                <img src="/images/logo_2HOME.png" alt="Logo" className="quantum-nav__logo-img" /><span className="Humanex_logo_title">umanex</span>
              </div>
            </Link>
          </div>

          {/* Center Navigation Menu */}
          <div className="cc-nav-links-main">
            {/* Businesses Dropdown - 4 Columns */}
            <div className="cc-nav-item cc-dropdown">
              <button className="cc-nav-link-item cc-dropdown-toggle">
                Businesses
                <span className="cc-dropdown-arrow">▼</span>
              </button>
              <div className="cc-dropdown-menu">
                <div className="cc-dropdown-grid cc-three-column">
                  <div className="cc-dropdown-column">
                    <h4 className="cc-dropdown-title">Recruitment & Hiring</h4>
                    <Link to="/requirement-platform" className="cc-dropdown-link">
                      <FaUserTie className="cc-dropdown-icon" />
                      Requirement Platform
                    </Link>
                    <Link to="/access-recruit" className="cc-dropdown-link">
                      <FaUserPlus className="cc-dropdown-icon" />
                      Access Recruit
                    </Link>
                    <Link to="/performance-management" className="cc-dropdown-link">
                      <FaChartBar className="cc-dropdown-icon" />
                      Performance Management
                    </Link>
                  </div>
                  <div className="cc-dropdown-column">
                    <h4 className="cc-dropdown-title">Employee Management</h4>
                    <Link to="/onboarding" className="cc-dropdown-link">
                      <FaUserFriends className="cc-dropdown-icon" />
                      Employee Onboarding
                    </Link>
                    <Link to="/employeeportal" className="cc-dropdown-link">
                      <FaUsers className="cc-dropdown-icon" />
                      Employee Portal
                    </Link>
                    <Link to="/time-attendance" className="cc-dropdown-link">
                      <FaClock className="cc-dropdown-icon" />
                      Time & Attendance
                    </Link>
                  </div>
                  <div className="cc-dropdown-column">
                    <h4 className="cc-dropdown-title">Development & Analytics</h4>
                    <Link to="/training-development" className="cc-dropdown-link">
                      <FaGraduationCap className="cc-dropdown-icon" />
                      Training & Development
                    </Link>
                    <Link to="/reports" className="cc-dropdown-link">
                      <FaChartLine className="cc-dropdown-icon" />
                      Reports & Insights
                    </Link>
                  </div>
                  <div className="verticalesline"></div>
                  <div className="cc-dropdown-column image-column">
                    <img src="/images/business_nav.png"/>
                  </div>
                </div>
              </div>
            </div>

            {/* Features Dropdown - 4 Columns (Updated) */}
            <div className="cc-nav-item cc-dropdown">
              <button className="cc-nav-link-item cc-dropdown-toggle">
                Features
                <span className="cc-dropdown-arrow">▼</span>
              </button>
              <div className="cc-dropdown-menu cc-features-menu">
                <div className="cc-dropdown-grid cc-three-column">
                  <div className="cc-dropdown-column">
                    <h4 className="cc-dropdown-title">Automation</h4>
                    <Link to="/automation" className="cc-dropdown-link">
                      <FaRobot className="cc-dropdown-icon" />
                      Service Automation
                    </Link>
                    <Link to="/document-management" className="cc-dropdown-link">
                      <FaFolderOpen className="cc-dropdown-icon" />
                      Document Management
                    </Link>
                    <Link to="/approval-workflows" className="cc-dropdown-link">
                      <FaCheckCircle className="cc-dropdown-icon" />
                      Approval Workflows
                    </Link>
                  </div>
                  <div className="cc-dropdown-column">
                    <h4 className="cc-dropdown-title">Compliance & Security</h4>
                    <Link to="/compliance" className="cc-dropdown-link">
                      <FaShieldAlt className="cc-dropdown-icon" />
                      Compliance Tracking
                    </Link>
                    <Link to="/privacy" className="cc-dropdown-link">
                      <FaLock className="cc-dropdown-icon" />
                      Privacy & Security
                    </Link>
                    <Link to="/workflow-management" className="cc-dropdown-link">
                      <FaExchangeAlt className="cc-dropdown-icon" />
                      Workflow Management
                    </Link>
                  </div>
                  <div className="cc-dropdown-column">
                    <h4 className="cc-dropdown-title">Management Tools</h4>
                    <Link to="/benefits-admin" className="cc-dropdown-link">
                      <FaGift className="cc-dropdown-icon" />
                      Benefits Administration
                    </Link>
                    <Link to="/managerlogin" className="cc-dropdown-link">
                      <FaUserTie className="cc-dropdown-icon" />
                      Manager Dashboard
                    </Link>
                  </div>
                  <div className="verticalesline"></div>
                 <div className="cc-dropdown-column image-column">
                  <div className=""></div>
                    <img src="/images/features_nav.png"/>
                  </div>
                </div>
              </div>
            </div>

            {/* Portals Dropdown  -4 columns */}
            <div className="cc-nav-item cc-dropdown">
              <button className="cc-nav-link-item cc-dropdown-toggle">
                Portals
                <span className="cc-dropdown-arrow">▼</span>
              </button>
              <div className="cc-dropdown-menu cc-pricing-menu">
                <div className="cc-dropdown-grid cc-single-column">
                  <div className="cc-dropdown-column">
                    <h4 className="cc-dropdown-title">Access Portals</h4>
                    <Link to="/access-recruit" className="cc-dropdown-link">
                      <FaRocket className="cc-dropdown-icon" />
                      Hiring Portal
                    </Link>
                    <Link to="/hr-login" className="cc-dropdown-link">
                      <FaUserCheck className="cc-dropdown-icon" />
                      HR Portal
                    </Link>
                    <Link to="/managerlogin" className="cc-dropdown-link">
                      <FaUserTie className="cc-dropdown-icon" />
                      Manager Portal
                    </Link>
                    <Link to="/employeelogin" className="cc-dropdown-link">
                      <FaIdCard className="cc-dropdown-icon" />
                      Employee Portal
                    </Link>
                  </div>
                  <div className="verticalesline"></div>
                   <div className="cc-dropdown-column image-column">
                    <img src="/images/image_of.png"/>
                  </div>
                </div>
              </div>
            </div>

            {/* Resources Dropdown -4 columns */}
            <div className="cc-nav-item cc-dropdown">
              <button className="cc-nav-link-item cc-dropdown-toggle">
                Resources
                <span className="cc-dropdown-arrow">▼</span>
              </button>
              <div className="cc-dropdown-menu">
                <div className="cc-dropdown-grid cc-two-column">
                  <div className="cc-dropdown-column">
                    <h4 className="cc-dropdown-title">About Us</h4>
                    <Link to="/aboutpage" className="cc-dropdown-link">
                      <FaInfoCircle className="cc-dropdown-icon" />
                      About Company
                    </Link>
                    <Link to="/community" className="cc-dropdown-link">
                      <FaGlobe className="cc-dropdown-icon" />
                      Community
                    </Link>
                  </div>
                  <div className="cc-dropdown-column">
                    <h4 className="cc-dropdown-title">Support & Help</h4>
                    <Link to="/contact" className="cc-dropdown-link">
                      <FaHandshake className="cc-dropdown-icon" />
                      Support Center
                    </Link>
                    <Link to="/privacy" className="cc-dropdown-link">
                      <FaFileContract className="cc-dropdown-icon" />
                      Legal & Privacy
                    </Link>
                  </div>

                  <div className="verticalesline"></div>
                  <div className="cc-dropdown-column image-column">
                    <img src="/images/protals.jpg"/>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Section - Auth & Translator */} 
          <div className="quantum-nav__right">
            {/* <WebsiteTranslator /> */}

            {/* Auth Buttons for Desktop */}
            <div className="quantum-nav__auth quantum-nav__auth--desktop">
              <button
                className="quantum-nav__auth-btn quantum-nav__auth-btn--login"
                onClick={handleLogin}
              >
                <FaUser className="quantum-nav__icon" />
                <span>Login</span>
              </button>
              <button
                className="quantum-nav__auth-btn quantum-nav__auth-btn--cta"
                onClick={handleGetStarted}
              >
                <FaRocket className="quantum-nav__icon" />
                <span>Start Hiring</span>
                <div className="quantum-nav__auth-btn-glow"></div>
              </button>
            </div>

            {/* Mobile Toggle */}
            <div className="quantum-nav__toggle" onClick={toggleMenu}>
              <div className={`quantum-nav__hamburger ${menuOpen ? "quantum-nav__hamburger--active" : ""}`}>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        </div>

        {/* Animated Background */}
        <div className="quantum-nav__background">
          <div className="quantum-nav__particles">
            {[...Array(12)].map((_, i) => (
              <div key={i} className="quantum-nav__particle" style={{
                '--i': i,
                '--delay': Math.random() * 3,
                '--duration': 4 + Math.random() * 3,
                '--size': 3 + Math.random() * 5
              }}></div>
            ))}
          </div>
        </div>
      </nav>

      {/* Overlay for mobile menu */}
      <div
        className={`quantum-nav__overlay ${menuOpen ? "quantum-nav__overlay--active" : ""}`}
        onClick={() => setMenuOpen(false)}
      />

      {/* AccessRecruitPage Modal */}
      {authModalOpen && (
        <AccessRecruitModal
          isOpen={authModalOpen}
          onClose={closeAuthModal}
          isLoginForm={isLoginForm}
          setIsLoginForm={setIsLoginForm}
        />
      )}
    </>
  );
}

const AccessRecruitModal = ({ isOpen, onClose, isLoginForm, setIsLoginForm }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  if (!isOpen) return null;

  return (
    <div className="access-recruit-modal">
      <div className="access-recruit-modal__backdrop"></div>
      <div className="access-recruit-modal__container" ref={modalRef}>
        <button className="access-recruit-modal__close" onClick={onClose}>
          <FaTimes />
        </button>
        <div className="access-recruit-modal__content">
          <AccessRecruitPage
            initialIsLogin={isLoginForm}
            onAuthSwitch={(isLogin) => setIsLoginForm(isLogin)}
            onSuccess={onClose}
            isModal={true}
          />
        </div>
      </div>
    </div>
  );
};